import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import apiClient from '../../acciones/apiClient';
import "./cap.css";

import { NavBar } from "../../componentes/navbar/index";
import { ImgCabecera } from '../../componentes/imgCabecera/imgCabe';

import { jwtDecode } from 'jwt-decode';
import Loader from "../../componentes/loader/loader";

export const Cap = () => {
    const { id } = useParams();
    const [tituloCapitulo, setTituloCapitulo] = useState("Cargando...");
    const [imagenes, setImagenes] = useState([]);
    const history = useHistory();

    const [capituloAnterior, setCapituloAnterior] = useState(null);
    const [capituloSiguiente, setCapituloSiguiente] = useState(null);
    const [comentarios, setComentarios] = useState([]);
    const [nuevoComentario, setNuevoComentario] = useState("");
    const [proyectoId, setProyectoId] = useState(null);
    const [contenido, setContenido] = useState(null);
    const [isNovela, setIsNovela] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchCapitulo = async () => {
            try {
                const response = await apiClient.get(`/capitulos/${id}/imagenes`);
                const { titulo, imagenes, anterior, siguiente, comentario, proyectoId } = response.data;

                setTituloCapitulo(titulo);
                setImagenes(imagenes);
                setCapituloAnterior(anterior);
                setCapituloSiguiente(siguiente);
                setComentarios(comentario);
                setProyectoId(proyectoId);
                setIsNovela(typeof contenido === 'string');
                setContenido(contenido);
                setLoading(false);

                // Incrementar vistas solo una vez por capítulo
                const vistos = JSON.parse(localStorage.getItem("capitulosVistos") || "[]");
                if (!vistos.includes(id)) {
                    if (proyectoId) {
                        await apiClient.put(`/proyectos/${proyectoId}/increment-view`);
                        console.log(`Vista incrementada para el proyecto con ID ${proyectoId}`);
                    }
                    vistos.push(id);
                    localStorage.setItem("capitulosVistos", JSON.stringify(vistos));
                }

            } catch (error) {
                console.error("Error al obtener los datos del capítulo:", error);
            }
        };

        fetchCapitulo();
    }, [id]);

    const manejarNavegacion = (nuevoId) => {
        if (nuevoId) history.push(`/capitulo/${nuevoId}`);
    };

    const bloquearContexto = (e) => {
        e.preventDefault();
    };

    const handleEnviarComentario = async () => {
        if (!nuevoComentario.trim()) return;
        try {
            const usuario_id = jwtDecode(localStorage.getItem('token')).id;
            await apiClient.post(`/capitulos/${id}/comentarios`, {
                comentario: nuevoComentario,
                usuario_id,
                proyecto_id: id,
                capitulo_id: id,
            });
            setComentarios((prev) => [
                { usuario: "Tú", comentario: nuevoComentario },
                ...prev,
            ]);
            setNuevoComentario("");
        } catch (error) {
            console.error("Error al enviar el comentario:", error);
            setLoading(false);
        }
    };

    return (
        <div>
            <ImgCabecera />
            <NavBar />

            <h1 className="tituloCap">{tituloCapitulo}</h1>

            <div className="navigation">
                <button
                    className="nav-button"
                    onClick={() => manejarNavegacion(capituloAnterior)}
                    disabled={!capituloAnterior}
                >
                    « Capítulo Anterior
                </button>
                <button
                    className="nav-button"
                    onClick={() => manejarNavegacion(capituloSiguiente)}
                    disabled={!capituloSiguiente}
                >
                    Siguiente Capítulo »
                </button>
            </div>

            <div className="hojasCap">
                {Array.isArray(imagenes) && imagenes.length > 0 ? (
                    imagenes.map((imagen, index) => (
                        <img
                            key={index}
                            src={imagen}
                            alt={`Hoja ${index + 1}`}
                            onContextMenu={bloquearContexto}
                            style={{ userSelect: "none" }}
                        />
                    ))
                ) : typeof imagenes === 'string' && imagenes.trim().length > 0 ? (
                    <div
                        className="contenido-novela"
                        dangerouslySetInnerHTML={{ __html: imagenes }}
                    />
                ) : (
                    <Loader />
                )}
            </div>

            <div className="navigation">
                <button
                    className="nav-button"
                    onClick={() => manejarNavegacion(capituloAnterior)}
                    disabled={!capituloAnterior}
                >
                    « Capítulo Anterior
                </button>
                <button
                    className="nav-button"
                    onClick={() => manejarNavegacion(capituloSiguiente)}
                    disabled={!capituloSiguiente}
                >
                    Siguiente Capítulo »
                </button>
            </div>

            <div className="rating">
                {[1, 2, 3, 4, 5].map((num) => (
                    <React.Fragment key={num}>
                        <input type="radio" id={`star-${num}`} name="star-radio" value={`star-${num}`} />
                        <label htmlFor={`star-${num}`}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                <path pathLength="360" d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"></path>
                            </svg>
                        </label>
                    </React.Fragment>
                ))}
            </div>

            <div className="comentarios-tabProyecto">
                <h3 className="comentarios-capitulo">Comentarios</h3>
                <div className="comentarios-containerProyecto">
                    <div className="comentarios-input-container">
                        <textarea
                            className="comentarios-textarea"
                            placeholder="Escribe tu comentario aquí..."
                            value={nuevoComentario}
                            onChange={(e) => setNuevoComentario(e.target.value)}
                        />
                        <button
                            className="comentarios-boton-enviar"
                            onClick={handleEnviarComentario}
                        >
                            Enviar
                        </button>
                    </div>

                    <div className="comentarios-lista">
                        {Array.isArray(comentarios) && comentarios.length > 0 ? (
                            comentarios.map((comentario, index) => (
                                <div className="comentario-item" key={index}>
                                    <p className="comentario-usuario">
                                        {comentario.usuario.nombre_usuario}:
                                    </p>
                                    <p className="comentario-texto">{comentario.comentario}</p>
                                </div>
                            ))
                        ) : (
                            <p className="comentarios-vacio">No hay comentarios aún. Sé el primero en comentar.</p>
                        )}
                    </div>
                    <br /><br />
                </div>
            </div>
        </div>
    );
};
